import { createClient } from '@supabase/supabase-js';

// No fallback to the old qlkytkipidjhyyvmkead project URL — that project is
// paused, and nothing in this app creates a Supabase session anymore
// (useAuth.tsx moved to Convex Auth); this client only exists for
// services/api.ts's fetchWithAuth fallback read, which finds no session and
// degrades gracefully either way. Placeholder values keep createClient from
// throwing synchronously when the env vars are unset.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://missing-supabase-url.invalid';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'missing-anon-key';

if (import.meta.env.DEV && !import.meta.env.VITE_SUPABASE_ANON_KEY) {
  console.error('Missing VITE_SUPABASE_ANON_KEY environment variable. Supabase auth will fail.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Use sessionStorage instead of localStorage to mitigate XSS token theft
    storage: {
      getItem: (key) => {
        try { return sessionStorage.getItem(key); } catch { return null; }
      },
      setItem: (key, value) => {
        try { sessionStorage.setItem(key, value); } catch { /* noop */ }
      },
      removeItem: (key) => {
        try { sessionStorage.removeItem(key); } catch { /* noop */ }
      },
    },
  },
});

export default supabase;
